<template>
  <div
    class="code-input-container"
  >
    <div
      v-for="(code, index) in codeList"
      :key="index"
      :style="style"
      class="code-input-box"
      @click="setFocus"
    >
      <span
        v-if="code !== '|'"
      >
        {{ code === '-' ? '' : code }}
      </span>
      <span
        v-else
        class="blink"
      >
        |
      </span>
    </div>
    <input
      ref="myInput"
      v-model="code"
      style="z-index: -9999; position: fixed; top: 0; left: 0; opacity: 0;"
      @keyup="checkCode"
      @blur="setFocus"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CodeInput',
  data () {
    return {
      code: ''
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo']),
    style () {
      return {
        'background-color': `${this.estilo.aplicacao.corPrimariaAplicacao}14`,
        'color': this.estilo.aplicacao.corPrimariaAplicacao
      }
    },
    styleSelected () {
      return {
        'background-color': `${this.estilo.aplicacao.corPrimariaAplicacao}3C`,
        'color': this.estilo.aplicacao.corPrimariaAplicacao
      }
    },
    codeList () {
      let myCode = this.code.substr(0, 5)
      let size = 5 - myCode.length
      if (size < 1) {
        return myCode
      }

      for (let i = 0; i < size; i++) {
        if (i === 0) {
          myCode += '|'
        } else {
          myCode += '-'
        }
      }

      return myCode
    }
  },
  methods: {
    select (index) {
      this.codeList.forEach((v, i) => {
        v.selected = i === index
      })
    },
    setFocus () {
      try {
        this.$refs.myInput.focus()
      } catch (ignored) {}
    },
    checkCode () {
      if (this.code.length > 5) {
        this.code = this.code.substr(0, 5)
      }

      if (this.code.length === 5) {
        this.$emit('check', this.code)
      }
    }
  },
  mounted () {
    this.setFocus()
  }
}
</script>
<style scoped>
.code-input-container {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  column-gap: 10px;
  margin-top: 5px;
  margin-bottom: 20px;
}

.code-input-box {
  width: 50px;
  height: 56px;
  font: normal normal 600 30px/36px SF Pro Text;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
}

.blink {
  color: black;
  animation: animate 0.7s alternate infinite;
}

@keyframes animate{
  0%{
    opacity: 0;
  }
  100%{
    opacity: 1;
  }
}
</style>
